import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

// This module calls dayjs(...).calendar(...) directly, so it must extend
// the plugin itself rather than relying on some other file (e.g. the old
// LiveChat.jsx) having already called dayjs.extend(calendar) first.
dayjs.extend(calendar);

/**
 * Groups already-sorted messages into a flat render list with date
 * separators inserted between days. Extracted from the inline `.reduce`
 * that lived inside the JSX in the original component — same logic,
 * just testable and reusable outside of render.
 *
 * Returns an array of items: { type: "date", key, date } | { type: "message", key, message }
 */
export function buildMessageTimeline(messages) {
  const items = [];
  let prevDateKey = null;

  for (const msg of messages) {
    const date = msg.timestamp?.toDate ? msg.timestamp.toDate() : null;
    const dateKey = date ? dayjs(date).format("DD/MM/YYYY") : null;

    if (dateKey && dateKey !== prevDateKey) {
      items.push({ type: "date", key: `date-${dateKey}`, date });
      prevDateKey = dateKey;
    }

    items.push({ type: "message", key: msg.id, message: msg });
  }

  return items;
}

export function formatDateSeparator(date) {
  return dayjs(date).calendar(null, {
    sameDay: "[Today]",
    lastDay: "[Yesterday]",
    lastWeek: "dddd",
    sameElse: "DD/MM/YYYY",
  });
}